(() => {
  const DRAG_THRESHOLD = 4;

  const enableDragScroll = (el) => {
    if (!el || el.dataset.campagneFaqDrag === '1') return;
    el.dataset.campagneFaqDrag = '1';

    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let suppressClick = false;

    const onPointerDown = (event) => {
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = el.scrollLeft;
      dragging = false;
      suppressClick = false;
      el.setPointerCapture?.(pointerId);
      el.style.cursor = 'grabbing';
    };

    const onPointerMove = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const delta = event.clientX - startX;

      if (!dragging && Math.abs(delta) > DRAG_THRESHOLD) {
        dragging = true;
        suppressClick = true;
      }

      if (!dragging) return;

      el.scrollLeft = startScroll - delta;
      event.preventDefault();
    };

    const onPointerUp = (event) => {
      if (pointerId === null || event.pointerId !== pointerId) return;

      pointerId = null;
      dragging = false;
      el.style.cursor = 'grab';
      el.releasePointerCapture?.(event.pointerId);
    };

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);
    el.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  };

  const init = () => {
    if (!document.body.classList.contains('pb-campagne-product')) return;

    const tabs = document.querySelectorAll('.faq-section .faq-tabs');

    for (const row of tabs) {
      enableDragScroll(row);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
